var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_449_956)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.2983,
    cy: 16.5281,
    r: 12,
    stroke: "#5CBD20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.9648,
    cy: 13.1948,
    r: 2,
    fill: "#5CBD20"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.6318,
    cy: 13.1948,
    r: 2,
    fill: "#5CBD20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2475 19.7196C20.574 21.104 18.4701 21.8615 16.2982 21.8615C14.1263 21.8615 12.0224 21.104 10.3489 19.7196",
    stroke: "#5CBD20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_449_956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.29834 0.528076)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.88f8f176f34f07d90511159c75366016.svg";
export { ForwardRef as ReactComponent };